// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/operacional/services/davService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import { paramsDaLista, type ListaFiltros, type PaginadoComResumo, type DavListaResumo } from './listaFiltros';
import type {
  DavResumo,
  DavDetalhe,
  CriarDavRequest,
  AtualizarDavRequest,
  EstornarDavRequest,
} from '../types';

const BASE = '/api/dav';

export const davService = {
  async getAll(pagina = 1, tamanhoPagina = 50, filtros: ListaFiltros = {}): Promise<PaginadoComResumo<DavResumo, DavListaResumo>> {
    const { data } = await apiClient.get<PaginadoComResumo<DavResumo, DavListaResumo>>(BASE, {
      params: paramsDaLista(pagina, tamanhoPagina, filtros),
    });
    return data;
  },

  async getAbertos(): Promise<DavResumo[]> {
    const { data } = await apiClient.get<DavResumo[]>(`${BASE}/abertos`);
    return data;
  },

  async getPendentesEntrega(): Promise<DavResumo[]> {
    const { data } = await apiClient.get<DavResumo[]>(`${BASE}/pendentes-entrega`);
    return data;
  },

  async getPorPeriodo(inicio: string, fim: string): Promise<DavResumo[]> {
    const { data } = await apiClient.get<DavResumo[]>(`${BASE}/periodo`, {
      params: { inicio, fim },
    });
    return data;
  },

  async getById(id: number): Promise<DavDetalhe> {
    const { data } = await apiClient.get<DavDetalhe>(`${BASE}/${id}`);
    return data;
  },

  async create(request: CriarDavRequest): Promise<DavDetalhe> {
    const { data } = await apiClient.post<DavDetalhe>(BASE, request);
    return data;
  },

  async update(id: number, request: AtualizarDavRequest): Promise<DavResumo> {
    const { data } = await apiClient.put<DavResumo>(`${BASE}/${id}`, request);
    return data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },

  async copiar(id: number): Promise<DavDetalhe> {
    const { data } = await apiClient.post<DavDetalhe>(`${BASE}/${id}/copiar`);
    return data;
  },

  async estornar(id: number, request: EstornarDavRequest): Promise<DavResumo> {
    const { data } = await apiClient.post<DavResumo>(`${BASE}/${id}/estornar`, request);
    return data;
  },
};
